import React from "react";
import { useTranslation } from "react-i18next";
import ZohoSmsHelpModal from "./ZohoSmsHelpModal"; // adjust path as needed

function ZohoInt({ zohoMisc, register, watch, setValue, getValues, errors }) {
  const { t } = useTranslation();

  const zohoEnabled = watch("zoho.enable_zoho");
  const ctcValue = parseInt(watch("zoho.ctc"));

  return (
    <>
      <div className="general-settings" id="Zoho">
        {t("Zoho")}
      </div>

      <div className="add-numbermain">
        <div className="tel-numbers">{t("EnableZoho")}</div>

        <div className="phoneselect">
          <label className="switch">
            <input
              className="form-control"
              type="checkbox"
              {...register("zoho.enable_zoho")}
            />
            <span className="slider round"></span>
          </label>
        </div>
      </div>

      {zohoEnabled && (
        <>
          <div className="ps-5">
            <div className="add-numbermain">
              <div className="tel-numbers">{t("Loginboundcalls")}</div>
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("zoho.log_in_calls")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">{t("Logoutboundcalls")}</div>
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("zoho.log_out_calls")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">
                {t("LogSMS")}
                {/* inline SMS help link/modal */}
                   <ZohoSmsHelpModal triggerVariant="link" />
              </div>
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("zoho.log_sms")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            <div className="add-numbermain">
              <div className="tel-numbers">{t("LogCallRecording")}</div>
              <div className="phoneselect">
                <label className="switch">
                  <input
                    className="form-control"
                    type="checkbox"
                    {...register("zoho.log_call_recording")}
                  />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>

            {/* CTC config */}
            <div className="add-numbermain">
              <div className="tel-numbers">{t("CTC")}</div>
              <div className="phoneselect w-20">
                <select
                  className="form-control form-select selectname w-100"
                  {...register("zoho.ctc", {
                    setValueAs: (value) => Number(value),
                  })}
                >
                  {Object.keys(zohoMisc).length > 0 &&
                    Object.entries(zohoMisc).map(([key, value]) => (
                      <option key={value} value={value}>
                        {key}
                      </option>
                    ))}
                </select>

                {ctcValue === 5 && (
                  <>
                    <input
                      type="text"
                      className="selectname w-100 mt-2"
                      {...register("zoho.pstn_number", {
                        required:
                          "Please enter a valid 10-digit US or Canadian phone number",
                      })}
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                    />
                    {errors?.zoho?.pstn_number && (
                      <p className="text-danger text-start">
                        {errors.zoho.pstn_number.message}
                      </p>
                    )}
                  </>
                )}
              </div>
            </div>

            {/* Streams.AI Desktop activation info */}
            <div className="mt-3">
              <div
                className="zoho-help-box"
              >
                <b  style={{
                  fontSize: "1.1rem"}}>Note:</b>{" "}
                      {t(
                        "ZohoDesktopActivationHelp",
                        `After saving these settings, each user must enable Zoho integration from the Streams.AI Desktop application: open the three-bar menu → Zoho Integration. A Zoho consent window will open; the user must allow the requested permissions. The integration is only active after the user completes this consent flow.`
                      )}
              </div>
            </div>
          </div>
        </>
      )}

      <div className="routing-border mt-2"></div>
    </>
  );
}

export default ZohoInt;
